angular
    .module('empower.lodgeClaim')
    .service('lodgeClaimService', ['$q', 'httpService', '$rootScope', 'commonConst',
        function ($q, httpService, $rootScope, commonConst) {
            return {
                getLodgeClaimHistory: getLodgeClaimHistory,
                saveLodgeClaimInfo: saveLodgeClaimInfo
            };

            function getLodgeClaimHistory(params) {
                var def = $q.defer(),
                    APITarget = 'api/vicpolicies/getvicinjuryhistory',
                    Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        PolicyId: params.PolicyId,
                        RowsPerPage: params.RowsPerPage || commonConst.ROWS_PER_PAGE,
                        PageNumber: params.PageNumber || 1,
                    });

                httpService.httpRequest(APITarget, Values).then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data));
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            } // getLodgeClaim History

            function saveLodgeClaimInfo(params) {
                var def = $q.defer(),
                    APITarget = 'api/file/submitvicinjurydone',
                    Values = JSON.stringify({
                        IsClaimant: $rootScope.user.IsClaimant,
                        UploadSession: params.UploadSession,
                        EmployerId: params.EmployerId,
                        WorkerName: params.WorkerName,
                        Comment: params.Comment,
                        PhoneNumber: params.PhoneNumber,
                        Address: params.Address,
                        DateOfBirth: params.DateOfBirth,
                        DocumentType: params.DocumentType,
                        UploadUserId: params.UploadUserId
                    });

                httpService.httpRequest(APITarget, Values, 'POST').then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data));
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            } // saveLodgeClaimInfo
        }
    ]);